import {AfterViewInit, Component, Directive, Input, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';

import {ToastrService} from 'ngx-toastr';
import {language} from '../../../../language/vn';
import {CommandUtil} from '../../../../global/commandutil';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {DatePipe} from '@angular/common';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {VanBanDen} from '../../../../models/vanbanden/vanbanden';
import {VanBanDenFile} from '../../../../models/vanbanden/vanbandenfile';
import {VanBanDenXL} from '../../../../models/vanbanden/vanbandenxl';
import {VanBanDenService} from '../../../../service/vanbanden/service-vanbanden';
import {VanBanDenFileService} from '../../../../service/vanbanden/service-vanbandenfile';
import {VanBanDenXLService} from '../../../../service/vanbanden/service-vanbandenxl';

import {VanBanDenComment} from '../../../../models/vanbanden/vanbandencomment';
import {NavItemService} from '../../../../service/staff/service-navitem';
import {ConfirmDialogComponent} from '../../../dialog/confirmdialog.component';
import {environment} from '../../../../../environments/environment';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {DanhSachTHToTrinhComponent} from './danhsach.component';
import {VanBanDenCommentService} from '../../../../service/vanbanden/service-vanbandencomment';
import {ToTrinh} from '../../../../models/totrinh/totrinh';
import {ToTrinhXuLy} from '../../../../models/totrinh/totrinhxuly';
import {ToTrinhComment} from '../../../../models/totrinh/totrinhcomment';
import {ToTrinhService} from '../../../../service/totrinh/service-totrinh';
import {ToTrinhFileService} from '../../../../service/totrinh/service-totrinhfile';
import {ToTrinhXuLyService} from '../../../../service/totrinh/service-totrinhxuly';
import {ToTrinhCommentService} from '../../../../service/totrinh/service-totrinhcomment';
import {DomSanitizer} from '@angular/platform-browser';
@Component({
  templateUrl: './tonghop.component.html',
  encapsulation: ViewEncapsulation.None

})
export class TongHopYKienToTrinhComponent implements OnInit, AfterViewInit {
  public id: number = -1;
  public language = language;
  public showAction = true;
  public totalItems: number = 0;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public  onClose: Subject<boolean>;
  public toTrinhItem: ToTrinh = new ToTrinh();
  public toTrinhXuLyItem: ToTrinhXuLy = new ToTrinhXuLy();
  public toTrinhCommentList: ToTrinhComment[] = [];
  public maNguoiXuLy: number = Sessioncommand.staffId;
  public hoanThanhList: ToTrinhXuLy[] = [];
  public chuaXuLyList: ToTrinhXuLy[] = [];
  public dangXuLyList: ToTrinhXuLy[] = [];
  public toTrinhXuLyList: ToTrinhXuLy[] = [];
  constructor(
    public toTrinhService: ToTrinhService,
    public toastr: ToastrService,
    public datepipe: DatePipe,
    public commandUtil: CommandUtil,
    public toTrinhFileService: ToTrinhFileService,
    public toTrinhXuLyService: ToTrinhXuLyService,
    public navItemService: NavItemService,
    public bsModalService: BsModalService,
    public _bsModalRef: BsModalRef,
    public toTrinhCommentService: ToTrinhCommentService,
    public sanitizer: DomSanitizer
  ) {
  }
  ngAfterViewInit() {
  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  ngOnInit(): void {
    this.onClose = new Subject();
  }


  public edit(id: number) {
    this.id = id;

    this.loadComment(id);
    this.toTrinhService.getById(id).subscribe(data => this.toTrinhItem = data);
    this.toTrinhXuLyService.findByMaYeuCau(id).subscribe( data => {this.toTrinhXuLyList = data;
      this.hoanThanhList = this.toTrinhXuLyList.filter( x => x.trangThai === environment.hoanthanh);
      this.dangXuLyList = this.toTrinhXuLyList.filter( x => x.trangThai === environment.dangxuly);
      this.chuaXuLyList = this.toTrinhXuLyList.filter( x => x.trangThai === environment.chuaxuly);
    });
    this.toTrinhXuLyService.getByMaVBAndMXL(id, Sessioncommand.staffId).subscribe(
      datax => this.toTrinhXuLyItem = datax);

  }
  public showXuLy(toTrinhList: ToTrinhXuLy[])
  {
    const modalEdit = this.bsModalService.show(DanhSachTHToTrinhComponent, {class: 'modal-lg'});
    (<DanhSachTHToTrinhComponent>modalEdit.content).edit(
      toTrinhList
    );
    (<DanhSachTHToTrinhComponent>modalEdit.content).onClose.subscribe(result => {
    });
  }
  public onSave(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }
  public loadComment(id: number)
  {
    this.toTrinhCommentService.getCountByKeyword(id).subscribe( data => this.totalItems = data);
    this.toTrinhCommentService.findAllByPaging(id, this.currentPage, this.maxSize).subscribe( data => this.toTrinhCommentList = data);
  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.loadComment(this.id);
  }

}

